export default "__VITE_ASSET__BvcMhCLc__"